RivalIQ.apps.Favorites.module('views.selectors', function (selectors, App, Backbone, Marionette, $, _, s) {

    'use strict';

    const ALL_COMPANY_SETS = 'all';

    selectors.DimensionValues = RivalIQ.apps.Dashboard.views.MultiSelectDropdown.mixin({

        mixins: {
            props: Marionette.Dashboard.mixins.Props,
            companySets: RivalIQ.apps.Shell.mixins.CompanySetEventsMixin
        },

        companySetEvents: {
            'change:name': 'render',
            'companySetsChanged': 'render'
        },

        isHighlighted: _.constant(false),

        showFilter: _.constant(true),

        initialize: function () {
            const me = this;

            RivalIQ.apps.Dashboard.views.MultiSelectDropdown.prototype.initialize.apply(me, arguments);

            Marionette.bindEntityEvents(me, me.dashboardModel.getWidget(), {
                'change:primaryDimension': 'onPrimaryDimensionChanged'
            });
        },

        applyDropdownState: function () {
            const me = this;

            let selectedCompanySetIds = me.getCheckboxesState().sort();
            const isAllSelected = _.includes(selectedCompanySetIds, ALL_COMPANY_SETS);
            if (isAllSelected) {
                selectedCompanySetIds = [];
            } else {
                selectedCompanySetIds = _.without(selectedCompanySetIds, ALL_COMPANY_SETS);
            }

            me.dashboardModel.getWidget().setProps({
                onlyCompanySetIds: selectedCompanySetIds.join(',')
            }, {
                navigate: false
            });

            me.selectableItems = me.getSelectableItems();
            me.resetState();
            me.ui.selectionSummary.html(me.getSelectionSummary());
        },

        onDropdownShown: function () {
            const me = this;

            me.onClearSearch();
            RivalIQ.apps.Dashboard.views.MultiSelectDropdown.prototype.onDropdownShown.apply(me, arguments);
        },

        onCancelClicked: function (e) {
            const me = this;

            e?.preventDefault();
            me.resetState();
            me.closeDropdown();
        },

        _getSelectedCompanySetIds: function () {
            const me = this;

            const userCompanySets = RivalIQ.state.companySets.getUserCompanySets();
            const validCompanySetIds = _.keyBy(_.map(userCompanySets, companySet => companySet.get('companySetId')));
            const onlyCompanySetIds = _((me.dashboardModel.getWidget().getProp('onlyCompanySetIds') || '').split(','))
                .filter(companySetId => {
                    return validCompanySetIds[companySetId];
                })
                .keyBy()
                .value();

            return onlyCompanySetIds;
        },

        getSelectableItems: function () {
            const me = this;

            const userCompanySets = RivalIQ.state.companySets.getUserCompanySets();
            const companyData = RivalIQ.state.landscape.get('companies');

            const onlyCompanySetIds = me._getSelectedCompanySetIds();
            const isAllSelected = _.isEmpty(onlyCompanySetIds);

            return [{
                id: ALL_COMPANY_SETS,
                labelName: me._getItemStr('All Company Sets'),
                selected: isAllSelected
            }].concat(_.map(userCompanySets, companySet => {

                const companySetName = companySet.get('name');
                const numCompanies = companyData.getCompanyCountByCompanySetName(companySetName);
                const companySetId = companySet.get('companySetId');
                return {
                    id: companySetId,
                    _companySetName: companySetName,
                    labelName: me._getItemStr(companySetName, numCompanies),
                    selected: isAllSelected || onlyCompanySetIds[companySetId]
                };
            }));
        },

        getVisibleItemIds: function (filter) {
            const me = this;

            const lcFilter = filter.toLocaleLowerCase().trim();
            return _(me.selectableItems)
                .filter(function (item) {
                    return ALL_COMPANY_SETS === item.id ||
                        !lcFilter ||
                        _.includes(item._companySetName.toLocaleLowerCase(), lcFilter);
                })
                .map('id')
                .value();
        },

        onCheckboxChange: function (e) {
            const me = this;

            const $target = $(e.target);
            const changedId = $target.data('post-tag-id');
            const checked = Boolean($target.prop('checked'));

            let newSelectableItems;
            if (changedId === ALL_COMPANY_SETS) {
                if (checked) {
                    newSelectableItems = _.map(me.selectableItems, function (item, idx) {
                        return _.defaults({
                            selected: true
                        }, item);
                    });
                } else {
                    // unclicking ALL means unselect all.
                    newSelectableItems = _.map(me.selectableItems, function (item) {
                        return _.defaults({
                            selected: false
                        }, item);
                    });
                }
            } else {

                const currentlyCompanySetIds = _.keyBy(me.getCheckboxesState());
                if (!checked) {
                    delete currentlyCompanySetIds[ALL_COMPANY_SETS];
                }

                newSelectableItems = _.map(me.selectableItems, function (item) {
                    return _.defaults({
                        selected: Boolean(currentlyCompanySetIds[item.id])
                    }, item);
                });

                if (checked) {
                    // if all the non-all items are checked, then be sure to check all too.
                    const allItemsSelected = _.every(newSelectableItems, item => item.id === ALL_COMPANY_SETS || item.selected);
                    if (allItemsSelected) {
                        newSelectableItems[0].selected = true;
                    }
                } else {
                    const anyItemNotSelected = _.exists(newSelectableItems, item => item.id !== ALL_COMPANY_SETS && !item.selected);
                    if (anyItemNotSelected) {
                        newSelectableItems[0].selected = false;
                    }
                }
            }

            // if all is selected, light up all the checkboxes
            if (newSelectableItems[0].selected) {
                _.each(newSelectableItems, function (item) {
                    item.selected = true;
                });
            }
            me.updateDropdownCheckboxes(newSelectableItems);

            const isAnySelected = _.some(newSelectableItems, 'selected');
            me.ui.controlButtons.toggleClass('hidden', !isAnySelected || !me._isCheckboxStateChanged());
        },

        onPrimaryDimensionChanged: function () {
            const me = this;
            me.render();
        },

        onRender: function () {
            const me = this;

            const primaryDimension = me.dashboardModel.getWidget().getProp('primaryDimension');
            const isLandscapeDashboard = me.dashboardModel.configuration.get('type') === RivalIQ.enums.visibility.LANDSCAPE;

            me.ui.dropdownToggle.toggleClass('disabled', primaryDimension !== 'companySetId' || !isLandscapeDashboard);
        },

        getSelectionSummary: function () {
            const me = this;

            // Only metric table supports custom dimention currently.
            const widget = me.dashboardModel.getWidget();
            if (widget.widgetId !== RivalIQ.enums.widgetTypes.METRIC_TABLE) {
                return 'N/A';
            }

            const primaryDimension = me.dashboardModel.getWidget().getProp('primaryDimension');

            if (!primaryDimension || primaryDimension === 'companyId') {
                return 'N/A';
            } else if (me.dashboardModel.configuration.get('type') !== RivalIQ.enums.visibility.LANDSCAPE) {
                return 'Only available in landscape dashboards';
            }

            const onlyCompanySetIds = me._getSelectedCompanySetIds();
            const isAllSelected = _.isEmpty(onlyCompanySetIds);

            if (isAllSelected) {
                return 'All Company Sets';
            } else {
                const companySetNames = _(onlyCompanySetIds)
                    .map(companySetId => {
                        const companySet = RivalIQ.state.companySets.get(Number(companySetId));
                        return companySet?.get('name');
                    })
                    .compact()
                    .value()
                    .sort();

                return companySetNames.join(', ');
            }
        },

        _getItemStr: function (label, count) {
            let html = $.tagHtml('span', {
                class: ['tag-name'],
                html: label
            });

            if (!_.isUndefined(count)) {
                html += $.tagHtml('span', {
                    class: ['text-muted'],
                    html: `(${count})`
                });
            }

            return html;
        },

        serializeData: function () {
            const me = this;

            const data = RivalIQ.apps.Dashboard.views.MultiSelectDropdown.prototype.serializeData.apply(me, arguments);
            data.selectorInfoMessage = 'Focus company is not automatically included in company sets.';
            return data;
        }
    });

}, window.s);
